import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';

import Headroom from 'headroom.js/dist/headroom.js';
window.Headroom = Headroom;

import sal from 'sal.js'

import { windowWatcher } from './components/window-watcher';
import { intro } from './components/intro';
import { header } from './components/header';
import { nav } from './components/nav';
import { anchorLinks } from './components/anchor-links';
import { collapsibleSections } from './components/collapsible-sections';
import { toggleSections } from './components/toggle-sections';
import { toggleViews } from './components/toggle-views';
import { filters } from './components/filters';
import { map } from './components/map';
import { videos } from './components/videos';
import { footer } from './components/footer';

window.main = window.main || {};

const $body = $('body');

let isHomepage = false;
let isTouchDevice = false;
let isNavToggled = false;

main.init = () => {

  if (history.scrollRestoration) {
    history.scrollRestoration = 'manual';
  }

  // window.onbeforeunload = function () {
  //   window.scrollTo(0, 0);
  // }

  sal({
    threshold: 0.01,
    once: false
  });

  function checkIfTouchDevice(){
    return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
  }

  if(checkIfTouchDevice() === true) {
    $body.addClass('is-touch');
    $body.addClass('is-mobile-device');
    isTouchDevice = true;
  }
  else {
    isTouchDevice = false;
  }

  if($body.hasClass('page--is-homepage')) {
    isHomepage = true;
  }

  windowWatcher();
  intro('.js-intro');
  anchorLinks('.js-intro');
  header(isTouchDevice);
  nav(isNavToggled);
  collapsibleSections();
  toggleSections();
  toggleViews();
  filters();
  map('.js-map');
  videos();
  footer();

};

$(main.init);
